export default {"src":"/_next/static/media/Pippen.c8b52f43.svg","height":350,"width":350,"blurWidth":0,"blurHeight":0};